export class UserChangePasswordModel {
  public userId: number;
  public email: string;
  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public activationCode: string;
}